module.exports = __webpack_public_path__ + "img/Neo-Tips-Pic2-300x197.fd3d06d1.png";